export default __webpack_public_path__ + "static/media/tabler-icon-qrcode.0abcea9b.svg";